<div class="overflow-auto hide-horizontal-scroll">
  @if (supportingDocumentMessage) {
    <div class="document-information-container">
      <div
        #divSupportingDocumentMessage
        [ngClass]="{ 'show-less-container': !isShowMore }"
        [innerHTML]="supportingDocumentMessage"
      ></div>
      <div class="margin-top-one-rem">
        <a href="javascript:;" (click)="onShowLessLinkClick()">{{
          isShowMore ? "Show Less..." : "Show More..."
        }}</a>
      </div>
    </div>
  }
  <p-table
    [value]="linkedDocuments"
    #allDocumentsList
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
    [(selection)]="selectedRowDocument"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="width-twenty overflow-wrap">Description</th>
        <th class="width-fifteen overflow-wrap">File Name</th>
        <th class="width-ten overflow-wrap">File Uploaded</th>
        <th class="width-ten overflow-wrap">Last Updated Date</th>
        <th class="width-ten overflow-wrap" [ariaHidden]="true"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-linkedDocuments let-i="rowIndex">
      <tr
        [pSelectableRow]="linkedDocuments"
        [selectedRowDocument]="linkedDocuments"
        rowId="{{ i }}"
      >
        @if (!linkedDocumentsFoundMessage) {}
        @if (linkedDocuments.isNew) {
          <td>
            <input
              class="full-width"
              pInputText
              required
              maxlength="100"
              type="text"
              [(ngModel)]="linkedDocuments.fileDescription"
              (input)="onChangeData()"
              attr.ri="{{ i }}"
              #descriptionInput="ngModel"
              aria-label="Description"
            />
            @if (
              (descriptionInput && descriptionInput.touched) ||
              descriptionInput.dirty
            ) {
              <div class="float-left">
                @if (descriptionInput.errors?.required) {
                  <small class="error-label">File description required</small>
                }
              </div>
            }
          </td>
        }
        @if (!linkedDocuments.isNew) {
          <td class="overflow-wrap">
            {{ linkedDocuments.fileDescription }}
          </td>
        }
        <td class="overflow-wrap">
          @if (linkedDocuments.documentUploaded === "Yes") {
            <div>
              <a
                href="#"
                (click)="
                  downloadExclusionLinkedDocument(
                    linkedDocuments.fileId,
                    linkedDocuments.fileName
                  )
                "
              >
                {{ linkedDocuments.fileName }}
              </a>
            </div>
          } @else {
            {{ linkedDocuments.fileName }}
          }
        </td>
        <td class="overflow-wrap">{{ linkedDocuments.documentUploaded }}</td>
        <td class="overflow-wrap">
          {{ linkedDocuments.lastUpdatedDate | date: "dd/MM/yyyy" }}
        </td>
        <td>
          @if (
            (!pupilData.isOffRoll || isOffRollEditingEnabled) &&
            linkedDocuments.isNew
          ) {
            <div>
              @if (!isCreateExclusion) {
                <button
                  pButton
                  type="button"
                  icon="pi pi-check"
                  class="ui-button-success margin-right-custom"
                  (click)="postFile()"
                  [disabled]="!linkedDocuments.fileDescription || isSaveClicked"
                  title="Save file upload"
                ></button>
              }
              <button
                pButton
                type="button"
                icon="pi pi-times"
                class="ui-button-danger"
                title="Cancel file upload"
                (click)="uploadCancelled(i)"
              ></button>
            </div>
          }
          @if (
            (!pupilData.isOffRoll || isOffRollEditingEnabled) &&
            !linkedDocuments.isNew
          ) {
            <div class="split-button-container-secondary">
              <p-splitButton
                label="Edit"
                value="Edit"
                (onClick)="editDocument(linkedDocuments, i)"
                class="button-custom float-right meeting-status-font"
                [model]="splitActionButtons[i]"
                [disabled]="isDisableSplitButton"
                attr.ri="{{ i }}"
                (onDropdownClick)="findTableRowIndex(i)"
                (keydown.Tab)="autoCloseSplitButton($event)"
                appendTo="body"
                #editDocumentSplitButton
              ></p-splitButton>
            </div>
          }
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      @if (linkedDocumentsFoundMessage) {
        <tr>
          <td [attr.colspan]="5">
            <div class="noRecordFoundMessage">
              No supporting documents have been uploaded for {{ pupilName }}
            </div>
          </td>
        </tr>
      }
    </ng-template>
  </p-table>
  <div class="grid">
    <div class="col-9"></div>
    <div class="col-3 whitespace-top">
      @if (
        (!pupilData.isOffRoll || isOffRollEditingEnabled) &&
        (linkedDocuments || linkedDocumentsFoundMessage)
      ) {
        <span> {{ allowedFileInfo }}</span>
      }
    </div>
  </div>
  @if (
    (!pupilData.isOffRoll || isOffRollEditingEnabled) &&
    (linkedDocuments || linkedDocumentsFoundMessage) &&
    !isAddDocHidden
  ) {
    <div class="grid">
      <div class="col">
        <button
          pButton
          #addDocumentButton
          type="button"
          class="float-right"
          label="Add Document"
          (click)="file.click()"
          title="Add Document"
          [disabled]="isUpdateMode && isEditMode"
        ></button>
      </div>
    </div>
  }
</div>
<input
  type="file"
  id="file"
  class="hide"
  (change)="handleFileInput($event.target.files)"
  (click)="$event.target.value = null"
  [accept]="allowedFileTypes"
  #file
/>
